import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Icons, WhetherIconTitle, WhetherIconsWithAnimations } from "../../../constants";
import { WeatherIconData } from "../../../data/icons/WhetherIcon";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";

const WhetherIconContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={WhetherIconTitle} parent={Icons} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CommonCardHeader title={WhetherIconsWithAnimations} />
              <CardBody>
                <Row className="icon-lists whether-icon">
                  {WeatherIconData.map((icon, i) => (
                    <Col lg="2" xs="3" key={i}>
                      {icon.icon}
                    </Col>
                  ))}
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};
export default WhetherIconContainer;
